import AppUtils from "../AppUtils";
import { getDivTemplate, getSpanTemplate, getPdfRowTemplate, getPdfColTemplate } from "../../PdfTemplates/prescriptionBody";
import { isEmpty as _isEmpty, map as _map, get as _get } from "lodash";
import { IPdfTemplates } from "../../models/PdfTemplatesModels";
import { PrescriptionPdfSection, AppConstants, vitalHeaderMap } from "../AppConstants";
import { IConsultationPdfData } from "../../components/templates/CommonPrescriptionPdf";
import { IPatientVitalsUI } from "../../models/IPatientVitalResponse";


export interface IPhysioPrescriptionPdf {
    vitals: any
    planGoals: any
    planActivityRecommendation: any
    planAdditionalAdvice: any
    planPostSessionAdvice: any
    planProvisionalDiagnosis: any
    planProvisionalTreatmentPlan: any
    allergies: any
    prescriptionLabTest: any
    referral: any
    followup: any
    [key: string]: any
}

export const physioPrescriptionFormatState = (props: IConsultationPdfData): IPhysioPrescriptionPdf => {
    let prescriptionData = {} as IPhysioPrescriptionPdf;
    if (!_isEmpty(props)) {

        if (props.vitals) {
            const newVitals: Array<IPatientVitalsUI> = AppUtils.getRecentVitals(props.vitals);
            if (newVitals && newVitals.length > 0) {
                prescriptionData.vitals = newVitals;
            }
        }

        if (!_isEmpty(props.medicalProfile) && AppUtils.isDefined(props.medicalProfile.currentConsultationData)) {
            const data: any = { ...props.medicalProfile.currentConsultationData };
            if (!_isEmpty(data.planGoals) && AppUtils.isDefined(data.planGoals.activityList)) {
                prescriptionData.planGoals = data.planGoals.activityList;
            }
            if (!_isEmpty(data.planActivityRecommendation) && AppUtils.isDefined(data.planActivityRecommendation.activityRecommendationList)) {
                data.planActivityRecommendation.activityRecommendationList.map((activity: any) => {
                    prescriptionData[`activityRecommendation-${activity.activityRecommendationQuery}`] = activity.items;
                })
                prescriptionData.planActivityRecommendation = data.planActivityRecommendation.activityRecommendationList;
            }
            if (!_isEmpty(data.planAdditionalAdvice) && AppUtils.isDefined(data.planAdditionalAdvice.additionalAdvice)) {
                prescriptionData.planAdditionalAdvice = data.planAdditionalAdvice.additionalAdvice;
            }
            if (!_isEmpty(data.planPostSessionAdvice) && AppUtils.isDefined(data.planPostSessionAdvice.postSessionAdvice)) {
                prescriptionData.planPostSessionAdvice = data.planPostSessionAdvice.postSessionAdvice;
            }
            if (!_isEmpty(data.planProvisionalDiagnosis) && AppUtils.isDefined(data.planProvisionalDiagnosis.provisionalDiagnosisList)) {
                prescriptionData.planProvisionalDiagnosis = data.planProvisionalDiagnosis.provisionalDiagnosisList;
            }
            if (!_isEmpty(data.planProvisionalTreatmentPlan) && AppUtils.isDefined(data.planProvisionalTreatmentPlan.selectSessionTheme)) {
                prescriptionData.planProvisionalTreatmentPlan = data.planProvisionalTreatmentPlan.selectSessionTheme;
                for (let prescriptionDatumKey in prescriptionData["planProvisionalTreatmentPlan"]) {
                    prescriptionData.planProvisionalTreatmentPlan[prescriptionDatumKey].numberSession = prescriptionDatumKey;
                }
            }
            if (!_isEmpty(data.prescriptionLabTest) && AppUtils.isDefined(data.prescriptionLabTest.labTestList)) {
                prescriptionData.prescriptionLabTest = data.prescriptionLabTest.labTestList;
            }
            if (!_isEmpty(data.prescriptionInstructions)) {
                if (AppUtils.isDefined(data.prescriptionInstructions.referralInfoSet)) {
                    prescriptionData.referral = data.prescriptionInstructions.referralInfoSet;
                }
                if (AppUtils.isDefined(data.prescriptionInstructions.followupInfoSet)) {
                    prescriptionData.followup = data.prescriptionInstructions.followupInfoSet;
                }
            }
        }
    }
    return prescriptionData;
}

export const physioPrescriptionModifyTemplate = (
    pdfTemplates: IPdfTemplates,
    props: IConsultationPdfData,
    prescription: Readonly<any>,
    pageIndex?: number,
    templateList?: any[]
): string => {

    const getDoctorDetailsTemplate = () => {
        const doctorProfileObj = props.appointmentSchedule.doctor;
        if (pdfTemplates.templateNameToDataMap && pdfTemplates.templateNameToDataMap["doctorDetails"] && doctorProfileObj) {
            let doctorPrefix = !_isEmpty(doctorProfileObj.prefix) ? doctorProfileObj.prefix + " " : ""
            return pdfTemplates.templateNameToDataMap["doctorDetails"]
                .replace("$doctorName", doctorPrefix + !_isEmpty(doctorProfileObj.name) ? doctorProfileObj.name : "")
                .replace("$doctorQualifications", !_isEmpty(doctorProfileObj.qualification) ? doctorProfileObj.qualification : "")
                .replace("$doctorKmc", !_isEmpty(doctorProfileObj.registrationNumber) ? doctorProfileObj.registrationNumber : "")
                .replace("$centerName", props.appointmentSchedule.center.name);
        }
        return "";
    }

    const getPrescriptionCardHeaderTemplate = () => {
        if (pdfTemplates.templateNameToDataMap["prescriptionCardHeader"]) {
            const date = AppUtils.getDayEpochInfo(props.appointmentSchedule.startTime);
            const patientGender = props.patient.gender ? props.patient.gender.charAt(0) : "";
            const patientAge = props.patient.age && props.patient.age > 0 ? props.patient.age.toString() : "";
            let reasonForVisit = ""
            if (!_isEmpty(props.consultation.prescription.reasonForVisit) && !_isEmpty(props.consultation.prescription.reasonForVisit.reasonForVisitOptions)) {
                reasonForVisit = props.consultation.prescription.reasonForVisit.reasonForVisitOptions.reason
                if (reasonForVisit === "HCU") {
                    reasonForVisit = "Health Checkup Report Review"
                }
                else if (reasonForVisit === "Follow Up") {
                    reasonForVisit += " Consultation"
                }
            }
            reasonForVisit = [...reasonForVisit].map((ch, i) => i === 0 ? ch.toUpperCase() : ch).join(""); // tmp hack
            const patientNameWithExtras = patientGender.length > 0 || patientAge.length > 0 ? `${props.patient.name} (
                            ${patientGender}
                            ${patientGender.length && patientAge.length ? "| " : ""}
                            ${patientAge})` : props.patient.name;
            return pdfTemplates.templateNameToDataMap["prescriptionCardHeader"]
                .replace("$patientName", patientNameWithExtras)
                .replace("$date", `${date.dateText} ${date.month}, ${date.year}`)
                .replace("$uhid", props.patient.uhid)
                .replace("$reasonForVisit", reasonForVisit)

        }
        return "";
    }

    const getSignatureTemplate = () => {
        if (pdfTemplates.templateNameToDataMap["signatureContainer"]) {
            return pdfTemplates.templateNameToDataMap["signatureContainer"]
                .replace("$signatureUrl", AppUtils.isDefined(props.signatureImagePreSignedUrl) ? props.signatureImagePreSignedUrl.url : "")
        }
        return "";
    }

    const getFooterTemplate = () => {
        if (pdfTemplates.templateNameToDataMap["footer"]) {
            return pdfTemplates.templateNameToDataMap["footer"]
                .replace("$centerName", props.appointmentSchedule.center.name)
                .replace("$centerAddress", props.appointmentSchedule.center.address)
                .replace("$centerPhone", props.appointmentSchedule.center.phone || "")
        }
        return "";
    }

    const getPrescriptionPdfTemplate = (pageIndex: number, totalPages?: number) => {
        let prescriptionTemp = "";
        const headerTemplate = pdfTemplates.templateNameToDataMap["carefitHeader"];
        let doctorDetailsTemplate = getDoctorDetailsTemplate();
        let prescriptionCardHeaderTemplate = getPrescriptionCardHeaderTemplate();
        let signatureContTemplate = getSignatureTemplate();
        const footerTemplate = getFooterTemplate();

        /* HEADER + DOCTOR DETAILS */
        prescriptionTemp += headerTemplate + doctorDetailsTemplate;

        let prescriptionBodyTemp = getDivTemplate("patient-prescription-body");
        let prescriptionBodyCardContTemp = getDivTemplate(`prescription-card physio-card`);
        let prescriptionCardContentTemplate = getDivTemplate("prescription-card-content-container").replace("$injectDivData", "$injectPrescriptionBody");

        let note = ""
        if (AppUtils.isTeleConsultationAppointment(props.appointmentSchedule)) {
            note = getDivTemplate("note").replace("$injectDivData", "Note: This prescription is generated on a teleconsultation")
        }

        /* PRESCRIPTION BODY(PATIENT'S DETAILS + SECTIONS BODY + SIGNATURE CONTAINER) + FOOTER */
        prescriptionTemp += prescriptionBodyTemp.replace(
            "$injectDivData",
            prescriptionBodyCardContTemp.replace(
                "$injectDivData", prescriptionCardHeaderTemplate
                + "<hr/>"
            + prescriptionCardContentTemplate
            )
            + getDivTemplate("prescription-page-index").replace(
                "$injectDivData", `Page :&nbsp;&#10222;&nbsp;${pageIndex && pageIndex > 0
                    ? pageIndex + 1
                    : 1
                } / ${totalPages || 1}&nbsp;&#10223;`
            + note
            )
            + signatureContTemplate
        )
            + footerTemplate;

        return getDivTemplate("patient-prescription-template physio-consultation-template")
            .replace("$injectDivData", prescriptionTemp);
    }

    const getVitalsTemplate = () => {
        if (prescription && prescription.vitals && prescription.vitals.length > 0) {
            let vitalsTemplate = pdfTemplates.templateNameToDataMap["vitals"];
            let vitalsBody = prescription.vitals.map((vitalItem: any) => {
                let vital: string = pdfTemplates.templateNameToDataMap["vital"];
                let vitalUnitText = !_isEmpty(vitalItem.unit) ? ` ( ${vitalItem.unit} )` : "";
                return vital.replace(
                    "$injectVitalName",
                    `${vitalHeaderMap[vitalItem.vitalName.toUpperCase()]} ${vitalUnitText}`
                ).replace(
                    "$injectVitalValue",
                    vitalItem.vital ? vitalItem.vital.value : ""
                );
            });
            return vitalsTemplate.replace("$injectVitals", vitalsBody.join("\n"));
        }
        return "";
    }

    const getProvisionalDiagnosisTemplate = (): string => {
        if (prescription && prescription.planProvisionalDiagnosis) {
            const diagnosisContainer: string = pdfTemplates.templateNameToDataMap["provisionalDiagnosis"];
            const diagnosisItems: string = !_isEmpty(prescription.planProvisionalDiagnosis) ? prescription.planProvisionalDiagnosis.map((item: any) => {
                return pdfTemplates.templateNameToDataMap["provisionalDiagnosisItem"]
                    .replace("$diagnosisName", item.imapactedArea.displayValue)
                    .replace("$diagnosisCondition", item.DiagnosedCondition && typeof item.DiagnosedCondition === "string" ? " - " + item.DiagnosedCondition : "")
                    .replace("$injectComments", item.comments
                        ? pdfTemplates.templateNameToDataMap["provisionalDiagnosisItemComment"].replace("$injectSpanData", `(${item.comments})`)
                        : ""
                    );
            }).join("") : "";
            return diagnosisContainer.replace("$injectDiagnosisBody", diagnosisItems);
        }
        return "";
    };

    const getGoalsTemplate = (): string => {
        if (prescription && !_isEmpty(prescription.planGoals)) {
            const containerTemplate = pdfTemplates.templateNameToDataMap["physioGoals"];
            const goalsItems = prescription.planGoals && prescription.planGoals.map((goal: any) => {
                const tableTemplate = pdfTemplates.templateNameToDataMap["physioGoalTable"].replace("$injectImpactedArea", goal.goalTheme);
                let tableBody = "";
                const goalCol = goal.items.filter((item: any) => item.physiotherapyGoal.displayValue !== "Functional Activity").map((item: any) => {
                    return pdfTemplates.templateNameToDataMap["physioGoalColumn"]
                        .replace("$injectGoalName", item.physiotherapyGoal.displayValue)
                        .replace("$injectCurrentValue", item.currentType)
                        .replace("$injectTargetValue", item.targetType)
                }).join("");
                tableBody += getPdfRowTemplate().replace("$injectRowBody", goalCol);
                const functionalActivity = goal.items.find((item: any) => item.physiotherapyGoal.displayValue === "Functional Activity");
                if (functionalActivity) {
                    const bodyText = getDivTemplate().replace(
                        "$injectDivData",
                        `Current: ${functionalActivity.currentType || ""}\n Target: ${functionalActivity.targetType || ""}`);
                    tableBody += pdfTemplates.templateNameToDataMap["physioGoalFunctionalActivity"].replace(
                        "$injectFunctionalActivityBody",
                        bodyText
                    )
                }
                return tableTemplate.replace("$injectTableBody", tableBody);
            }).join("");
            return containerTemplate.replace("$injectGoalsBody", goalsItems);
        }
        return "";
    }

    const getPhysioLabTestsTemplate = () => {
        if (prescription && prescription.prescriptionLabTest && prescription.prescriptionLabTest.length > 0) {
            const labTestContTemplate = pdfTemplates.templateNameToDataMap["physioLabTest"];
            const labTestBodyItems = prescription.prescriptionLabTest.map((test: any) => {
                const labTestBodyTemplate = getDivTemplate();
                let labTestBody = "";
                labTestBody += getSpanTemplate("prescription-subheading").replace("$injectSpanData", test.diagnosis.displayValue);
                if (test.medicineFrequency && test.medicineFrequency.count && test.medicineFrequency.unit) {
                    const dateText = `${test.medicineFrequency.count} ${test.medicineFrequency.unit.toLowerCase()}${test.medicineFrequency.count > 1 ? "s" : ""}`;
                    labTestBody += getSpanTemplate("prescription-description").replace("$injectSpanData", `&nbsp;- ${dateText}`);
                }
                if (test.instructions && test.instructions !== AppConstants.LabtestConditions.NONE) {
                    labTestBody += getSpanTemplate("prescription-subdesc").replace("$injectSpanData", `&nbsp;-&nbsp;${test.instructions}`);
                }
                if (test.comments) {
                    labTestBody += getSpanTemplate("prescription-subdesc").replace("$injectSpanData", `&nbsp;&#10222;&nbsp;${test.comments}&nbsp;&#10223;`);
                }
                return labTestBodyTemplate.replace("$injectDivData", labTestBody);
            });
            return labTestContTemplate.replace("$injectLabTestBodyCont", labTestBodyItems.join("\n"));
        }
        return "";
    }

    const getProvisionalTreatmentTemplate = () => {
        if (prescription && !_isEmpty(prescription.planProvisionalTreatmentPlan)) {
            const containerTemplate = pdfTemplates.templateNameToDataMap["provisionalTreatmentPlan"]
                .replace(
                    "$theme",
                    _get(props.medicalProfile.currentConsultationData, "planProvisionalTreatmentPlan.provisionalTheme.provisionalTreatmentPlaTagsSet", ""))
                .replace("$sessions", _get(props.medicalProfile.currentConsultationData, "planProvisionalTreatmentPlan.numberSessionTheme.session", ""));
            const sessionItems = prescription.planProvisionalTreatmentPlan && prescription.planProvisionalTreatmentPlan.map((sessionItem: any) => {
                const tableTemplate = pdfTemplates.templateNameToDataMap["provisionalTreatmentPlanTable"].replace(
                    "$injectSessionSequence",
                    (parseInt(sessionItem.numberSession) + 1).toString()
                );
                let tableBody = "";
                const plannedTreatment = sessionItem.items.filter((item: any) =>
                    item.productPlannedSelect && item.productPlannedSelect.displayValue
                ).map((item: any) => item.productPlannedSelect.displayValue);
                const actualTreatment = sessionItem.items.filter((item: any) =>
                    item.typePlannedSelect && item.typePlannedSelect.displayValue
                ).map((item: any) => item.typePlannedSelect.displayValue);
                const remarks = sessionItem.items.filter((item: any) => item.comments).map((item: any) => item.comments);
                if (!_isEmpty(plannedTreatment)) {
                    const header = getDivTemplate("col-header").replace("$injectDivData", "PLANNED TREATMENT");
                    tableBody += getPdfRowTemplate()
                        .replace(
                            "$injectRowBody",
                            getPdfColTemplate("col-header medium-text").replace("$injectColBody", header)
                            +
                            getPdfColTemplate().replace("$injectColBody", plannedTreatment.join(" + "))
                        );
                }
                if (!_isEmpty(actualTreatment)) {
                    const header = getDivTemplate("col-header medium-text").replace("$injectDivData", "ACTUAL TREATMENT");
                    tableBody += getPdfRowTemplate()
                        .replace(
                            "$injectRowBody",
                            getPdfColTemplate("col-header").replace("$injectColBody", header)
                            +
                            getPdfColTemplate().replace("$injectColBody", actualTreatment.join(" + "))
                        );
                }
                if (!_isEmpty(remarks)) {
                    const header = getDivTemplate("col-header medium-text").replace("$injectDivData", "REMARKS");
                    tableBody += getPdfRowTemplate()
                        .replace(
                            "$injectRowBody",
                            getPdfColTemplate("col-header").replace("$injectColBody", header)
                            +
                            getPdfColTemplate().replace("$injectColBody", remarks)
                        );
                }
                return tableTemplate.replace("$injectTableBody", tableBody);
            }).join("");
            return containerTemplate.replace("$injectProvisionalTreatmentBody", sessionItems);
        }
        return "";
    }

    const getPostSessionAdviceTemplate = () => {
        if (prescription && !_isEmpty(prescription.planPostSessionAdvice)) {
            const adviceItems = prescription.planPostSessionAdvice.map((item: any) =>
                pdfTemplates.templateNameToDataMap["postSessionAdviceItem"].replace(
                    "$injectAdviceInstruction",
                    item.postSessionAdviceAns.displayValue
                )
            ).join("");
            return pdfTemplates.templateNameToDataMap["postSessionAdvice"]
                .replace(
                    "$injectAdviceBody",
                    adviceItems
                )
        }
        return ""
    }

    const getAdditionalAdviceTemplate = () => {
        if (prescription && !_isEmpty(prescription.planAdditionalAdvice)) {
            const adviceItems = prescription.planAdditionalAdvice.map((item: any) =>
                pdfTemplates.templateNameToDataMap["additionalAdviceItem"].replace(
                    "$injectAdviceInstruction",
                    item.additionalAdviceComment.displayValue
                )
            ).join("");
            return pdfTemplates.templateNameToDataMap["additionalAdvice"]
                .replace(
                    "$injectAdviceBody",
                    adviceItems
                )
        }
        return ""
    }

    const getActivityRecommendationStretchingTemplate = (): string => {
        console.log(prescription, PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRETCHING)
        if (prescription && prescription[PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRETCHING]) {
            return getActivityRecommendationTemplate(prescription[PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRETCHING], "Stretching")
        }
        return "";
    }

    const getActivityRecommendationStrengtheningTemplate = (): string => {
        if (prescription && prescription[PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRENGTHENING]) {
            return getActivityRecommendationTemplate(prescription[PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRENGTHENING], "Strengthening")
        }
        return "";
    }

    const getActivityRecommendationWorkoutTemplate = (): string => {
        if (prescription && prescription[PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_WORKOUT]) {
            return getActivityRecommendationTemplate(prescription[PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_WORKOUT], "Workout")
        }
        return "";
    }

    const getActivityRecommendationTemplate = (data: Readonly<any>, theme: string): string => {
        if (!_isEmpty(data)) {
            let activityContainer = "";
            theme = theme.toLowerCase();
            if (theme === "workout") activityContainer = pdfTemplates.templateNameToDataMap["activityRecommendation-workout"];
            else if (theme === "strengthening") activityContainer = pdfTemplates.templateNameToDataMap["activityRecommendation-strengthening"];
            else activityContainer = pdfTemplates.templateNameToDataMap["activityRecommendation-stretching"];
            const header = theme.toUpperCase();
            const activities = data.map((item: any) => {
                let contTemplate = pdfTemplates.templateNameToDataMap["activityRecommendationItem"];
                const repsAndSetsText = (item.repititions ? `${item.repititions} reps` : "")
                    + (item.sets && item.repititions ? " x " : "")
                    + (item.sets ? `${item.sets} sets` : "");
                const activityName = getSpanTemplate("medium-text").replace("$injectSpanData", item.activityName.displayValue);
                const separator = getSpanTemplate("separator").replace("$injectSpanData", "");
                return contTemplate
                    .replace("$injectActivityHeader", activityName + (repsAndSetsText.length > 0 ? separator : " ") + repsAndSetsText)
                    .replace("$injectActivityBody", item.activityComments);
            }).join("");
            return activityContainer
                .replace("$injectActivityHeader", header)
                .replace("$injectActivityRecBody", activities);
        }
        return "";
    }

    const getPhysioReferralTemplate = () => {
        if (prescription && !_isEmpty(prescription.referral)) {
            let referralContTemplate = pdfTemplates.templateNameToDataMap["physioReferral"];
            const referralItems = _map(prescription.referral, (item: any, index: number) => {
                let referralItemBody = "";
                if (item && item.doctorSpecialityCode) {
                    referralItemBody += pdfTemplates.templateNameToDataMap["referralItemCode"].replace(
                        "$injectReferralCode",
                        item.doctorSpecialityCode || ""
                    );
                }
                if (item.when && item.when.unit && item.when.count) {
                    referralItemBody += pdfTemplates.templateNameToDataMap["referralItemDate"].replace(
                        "$injectReferralDate",
                        `${item.when.count} ${AppUtils.toCapitalize(item.when.unit)}${item.when && item.when > 0 ? "s" : ""}`
                    );
                }
                if (item.comment) {
                    referralItemBody += pdfTemplates.templateNameToDataMap["referralItemComment"].replace("$injectReferralComment", item.comment);
                }
                return getDivTemplate("referral-row-item").replace("$injectDivData", referralItemBody);
            });
            return referralContTemplate.replace("$injectReferralBody", referralItems.join("\n"));
        }
        return "";
    }

    const getPhysioFollowupTemplate = () => {
        if (prescription && !_isEmpty(prescription.followup) && !_isEmpty(prescription.followup[0].followUp)) {
            let referralContTemplate = pdfTemplates.templateNameToDataMap["physioFollowUp"];
            const referralItems = _map(prescription.followup, (item: any) => {
                let followupItemBody = "";
                if (item.followUp && item.followUp.unit && item.followUp.count) {
                    followupItemBody += pdfTemplates.templateNameToDataMap["followUpItemDate"].replace(
                        "$injectFollowupDate",
                        `${item.followUp.count} ${AppUtils.toCapitalize(item.followUp.unit)}${item.followUp && item.followUp.count > 0 ? "s" : ""}`
                    );
                }
                if (!_isEmpty(item.comment)) {
                    followupItemBody += pdfTemplates.templateNameToDataMap["followUpItemComment"].replace(
                        "$injectFollowupComment",
                        item.comment
                    );
                }
                return getDivTemplate("referral-row-item").replace("$injectDivData", followupItemBody);
            });
            return referralContTemplate.replace("$injectFollowupBody", referralItems.join("\n"));
        }
        return "";
    }

    let currTemplate: string = getPrescriptionPdfTemplate(pageIndex, (templateList || []).length);
    let injectedBody: string = "";
    const sectionTemplates = pdfTemplates.data.split(",").map((sectionId: string) => {
        const section = pdfTemplates.templateIdToNameMap[sectionId];
        switch (section) {
            case PrescriptionPdfSection.VITALS:
                return getVitalsTemplate();
            case PrescriptionPdfSection.PROVISIONAL_DIAGNOSIS:
                return getProvisionalDiagnosisTemplate()
            case PrescriptionPdfSection.GOALS:
                return getGoalsTemplate()
            case PrescriptionPdfSection.PROVISIONAL_TREATMENT_PLAN:
                return getProvisionalTreatmentTemplate()
            case PrescriptionPdfSection.POST_SESSION_ADVICE:
                return getPostSessionAdviceTemplate()
            case PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRENGTHENING:
                return getActivityRecommendationStrengtheningTemplate()
            case PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_STRETCHING:
                return getActivityRecommendationStretchingTemplate()
            case PrescriptionPdfSection.ACTIVITY_RECOMMENDATION_WORKOUT:
                return getActivityRecommendationWorkoutTemplate()
            case PrescriptionPdfSection.PHYSIO_REFERRAL:
                return getPhysioReferralTemplate()
            case PrescriptionPdfSection.PHYSIO_FOLLOWUP:
                return getPhysioFollowupTemplate()
            case PrescriptionPdfSection.ADDITIONAL_ADVICE:
                return getAdditionalAdviceTemplate()
            case PrescriptionPdfSection.PHYSIO_LAB_TEST:
                return getPhysioLabTestsTemplate()
            default:
                return ""
        }
    });
    injectedBody += sectionTemplates.join("\n");
    return currTemplate.replace("$injectPrescriptionBody", injectedBody);
}